import * as React from 'react';
import {useContext} from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl, {FormControlProps} from '@mui/material/FormControl';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import {ThemeContext, ThemeManagerContext} from '../../../Common/Contexts';
import {Theme, useTheme} from '@mui/material/styles';
import ControlButton from '../../../Common/ControlButton';
import Palette from '@mui/icons-material/Palette';
import Cloud from '@mui/icons-material/Cloud';
import Box from '../../../Common/Box';
import {InputBasePropsSizeOverrides, SxProps} from "@mui/material";
import {OverridableStringUnion} from "@mui/types";
import uiStore from "../../stores/uiStore";
import {ShadowTheme} from "../../clients/shadow/interfaces";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface ThemeSelectProps {
    size?: OverridableStringUnion<'small' | 'medium', InputBasePropsSizeOverrides>,
    variant?: 'standard' | 'outlined' | 'filled',
    withControls?: boolean,
    sx?: SxProps
}

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

//@todo check if this works
function getStyles(shadowTheme: ShadowTheme, themes: ShadowTheme[], muiTheme: Theme) {
    return {
        fontWeight:
                themes.indexOf(shadowTheme) === -1
                        ? muiTheme.typography.fontWeightRegular
                        : muiTheme.typography.fontWeightMedium,
    };
}

export default function ThemeSelect(
        {
            size,
            variant,
            withControls,
            sx
        }: ThemeSelectProps
) {
    const {
        shadowTheme,
        themes,
        setTheme,
    } = useContext(ThemeContext);

    const {
        paletteVisible,
        setPaletteVisible,
        cloudVisible,
        setCloudVisible,
    } = useContext(ThemeManagerContext);

    const currentTheme: Theme = useTheme();

    const handleChange = (event: SelectChangeEvent) => {
        const {
            target: {value},
        } = event;

        const [theme] = themes.filter(theme => theme.name === value)
        setTheme(theme);
    };
    let formProps: FormControlProps;

    if (uiStore.isMobile) {
        formProps = {
            size: "small",
            sx: {
                m: 1,
                flex: 1,
            }
        }

    } else {
        formProps = {
            size: "medium",
            sx: {
                m: 1,
                flex: 1,
                width: 300,
            }
        }
    }


    return (
            <Box
                    sx={sx ? sx : {
                        pointerEvents: "all",
                        flex: 1,
                    }}
                    row
                    center
            >

                <FormControl {...formProps}>
                    <InputLabel>Theme</InputLabel>
                    <Select
                            value={shadowTheme.name}
                            onChange={handleChange}
                            input={<OutlinedInput label="Theme"/>}
                            MenuProps={MenuProps}
                            size={size}
                            variant={variant}
                    >
                        {themes.map(theme => (
                                <MenuItem
                                        key={theme.name}
                                        value={theme.name}
                                        style={getStyles(theme, themes, currentTheme)}
                                >
                                    {theme.name}
                                </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {withControls && <>
                    <ControlButton
                            sx={{margin: "0 10px"}}
                            width={35}
                            enabled={paletteVisible}
                            icon={Palette}
                            label={"Theme manager"}
                            onClick={() => {
                                setPaletteVisible(!paletteVisible);
                                // setCloudVisible(false);
                            }}
                    />
                    <ControlButton
                            sx={{margin: "0 10px"}}
                            width={35}
                            enabled={cloudVisible}
                            icon={Cloud}
                            label={"All themes"}
                            onClick={() => {
                                setCloudVisible(!cloudVisible);
                                // setPaletteVisible(false);
                            }}
                    />
                </>}

            </Box>
    );
}
